import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import { API_URL, BRAND } from "../lib/brand";

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    axios.get(`${API_URL}/blog/${slug}`)
      .then((res) => setPost(res.data))
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  }, [slug]);

  if (loading) return <div className="pt-40 px-6 text-center text-[#3D2140]/50">Caricamento…</div>;
  if (error || !post) return (
    <div className="pt-40 px-6 text-center">
      <p className="text-[#3D2140]/60 mb-6">Articolo non trovato.</p>
      <Link to="/blog" className="btn-tv-primary">Torna al blog</Link>
    </div>
  );

  return (
    <article className="pt-32 md:pt-40 pb-16 px-6 md:px-10" data-testid="blog-post-page">
      <div className="max-w-3xl mx-auto">
        <Link to="/blog" className="inline-flex items-center gap-2 text-[#3D2140]/70 hover:text-[#FF2768] mb-8 text-sm uppercase tracking-widest">
          <ArrowLeft size={14} /> Torna al blog
        </Link>

        <div className="flex flex-wrap gap-2 mb-4">
          {(post.tags || []).map((t) => (
            <span key={t} className="text-[10px] uppercase tracking-widest text-[#FF2768] font-semibold">#{t}</span>
          ))}
        </div>

        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="font-display text-6xl md:text-8xl text-[#3D2140] leading-[0.9] mb-6"
        >
          {post.title}
        </motion.h1>

        <p className="text-xl text-[#3D2140]/70 leading-relaxed font-editorial italic mb-10">{post.excerpt}</p>

        {post.cover_image && (
          <div className="aspect-[16/10] overflow-hidden rounded-[24px] mb-12">
            <img src={post.cover_image} alt={post.title} className="w-full h-full object-cover" />
          </div>
        )}

        <div className="prose-tv">
          {post.content.split("\n\n").map((para, i) => (
            <p key={i}>{para}</p>
          ))}
        </div>

        <div className="mt-16 pt-10 border-t border-[#81C3C9]/40 flex items-center gap-4">
          <img src={BRAND.logo} alt="Logo" className="h-14 w-14 rounded-full" />
          <div>
            <p className="font-display text-2xl text-[#3D2140]">Teresa Vilardo</p>
            <p className="text-xs uppercase tracking-widest text-[#FF2768]">Family Coach Montessori</p>
          </div>
        </div>

        <div className="mt-10">
          <Link to="/prenota" className="btn-tv-primary" data-testid="post-cta-booking">
            Prenota una consulenza
          </Link>
        </div>
      </div>
    </article>
  );
}
